var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeHeavyMetals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 40,
    viewBox: "0 0 139 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2174_7649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.248 23.0098H98.3118V25.1695H91.6834V29.9139H98.3118V32.0735H91.6834V39.9885H89.248V22.9983V23.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.977 40V23.0098H105.228C106.951 23.0098 108.306 23.4348 109.317 24.2849C110.328 25.135 110.834 26.2837 110.834 27.7427C110.834 28.7306 110.581 29.5922 110.087 30.3044C109.593 31.0281 108.881 31.5681 107.962 31.9242C108.502 32.2803 109.03 32.7628 109.559 33.3831C110.076 34.0034 110.811 35.0718 111.753 36.5997C112.339 37.5646 112.821 38.2883 113.177 38.7708L114.073 39.9885H111.178L110.443 38.8742C110.443 38.8742 110.374 38.7593 110.294 38.6674L109.823 38.0012L109.065 36.7605L108.249 35.4394C107.744 34.7387 107.284 34.1872 106.87 33.7737C106.457 33.3601 106.078 33.0615 105.733 32.8777C105.4 32.6939 104.826 32.602 104.033 32.602H103.401V40H100.966H100.977ZM104.136 25.0775H103.413V30.4423H104.332C105.561 30.4423 106.411 30.3389 106.87 30.1206C107.33 29.9138 107.686 29.5922 107.939 29.1671C108.192 28.7421 108.318 28.2596 108.318 27.7197C108.318 27.1798 108.18 26.6973 107.893 26.2608C107.606 25.8242 107.215 25.5256 106.698 25.3418C106.181 25.1694 105.331 25.0775 104.136 25.0775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.945 23.0098H125.572V25.1695H118.369V30.3504H125.319V32.5216H118.369V37.7944H125.802V39.9541H115.945V22.9868V23.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.398 23.0098H138.025V25.1695H130.822V30.3504H137.772V32.5216H130.822V37.7944H138.255V39.9541H128.398V22.9868V23.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9816 0.0917969H14.417V17.082H11.9816V9.68399H2.43538V17.082H0V0.0917969H2.43538V7.43241H11.9816V0.0917969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1504 0.0917969H27.777V2.25148H20.5743V7.43241H27.5243V9.60357H20.5743V14.8764H28.0068V17.0361H18.1504V0.0917969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0249 0H37.7366L45.3529 17.0821H42.8601L40.597 12.0505H33.3483L31.2231 17.0821H28.7188L36.0249 0ZM39.5976 9.89087L36.852 3.73349L34.3132 9.89087H39.5976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9792 0.0917969H58.4031L51.2233 17.151H50.6719L43.3428 0.0917969H45.7896L50.9016 12.016L55.9792 0.0917969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4766 0.0917969H73.4289L67.1567 8.0872V17.0705H64.6639V8.0872L58.3916 0.0917969H61.3324L65.8815 5.9505L70.4766 0.0917969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6177 22.8145H26.8923V39.8047H24.4454V26.5824L19.2185 33.1533H18.7705L13.4862 26.5824V39.8047H11.0508V22.8145H13.3483L18.9887 29.7875L24.5947 22.8145H24.6177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5449 22.8145H40.1716V24.9742H32.9688V30.1551H39.9188V32.3263H32.9688V37.5991H40.4013V39.7588H30.5449V22.7915V22.8145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5508 22.7915H55.738V24.9512H49.8219V39.7932H47.375V24.9512H41.5508V22.7915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9761 22.7227H62.6877L70.304 39.8048H67.8112L65.5482 34.7732H58.2994L56.1742 39.8048H53.6699L60.9646 22.7227H60.9761ZM64.5487 32.602L61.8032 26.4447L59.2644 32.602H64.5487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1533 22.8145H74.5887V37.5876H82.2395V39.8047H72.1648V22.8145H72.1533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.252 0.0804163C96.8179 3.80242 91.3728 0.493972 86.9386 2.78001C83.6071 4.50316 82.5618 8.84549 82.2286 11.4991C82.2286 11.4991 79.7243 12.108 76.8639 11.9816C75.8989 11.9357 75.9219 13.969 76.726 14.0264C86.8237 14.8076 97.2085 4.96267 97.2085 4.96267C97.2085 4.96267 93.1189 13.6014 83.4578 15.7611C84.9167 16.7145 88.9259 19.1269 93.7507 16.0712C100.299 11.9357 103.527 -0.781157 102.263 0.0919039L102.252 0.0804163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2174_7649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.254,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeHeavyMetals);
export default __webpack_public_path__ + "static/media/free-heavy-metals.e8f19edb83f21e688d0a14cfc25e15ad.svg";
export { ForwardRef as ReactComponent };